(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/ticket-number/ticket-number.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/ticket-number/ticket-number.js');
"use strict";


setGlobal('svs.ticketgames.ticketUtility.components.TicketNumber', _ref => {
  let {
    ticketNumber
  } = _ref;
  return React.createElement("div", {
    className: "ticket-number absolute"
  }, ticketNumber);
});

 })(window);